import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import { supabase } from "./supabaseClient";

import NotFound from "./pages/NotFound";
import Leadership from "./pages/Leadership";
import ContactPage from "./pages/ContactPage";
import GetQuote from "./pages/GetQuote";
import Login from "./pages/Login";
import Admin from "./components/AdminLayout";
import DashboardHome from "./pages/Dashboard";
import Roster from "./pages/Roster";
import TestimonialAdmin from "./pages/TestimonialAdmin";
import TestimonialsArchive from "./pages/TestimonialsArchives";
import Products from "./pages/Products";
import Whoarewe from "./pages/Whoarewe";
import ServiceCharter from "./pages/ServiceCharter";
import ClaimForm from "./pages/Claimform";
import AdminClaims from "./pages/AdminCliam";
import AdminQuotes from "./pages/AdminQuotes.js";
import AdminInquiries from "./pages/AdminInquiries.js";


const AdminProtected = ({ children }) => {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getInitialSession = async () => {
      try {
        const {
          data: { session: currentSession },
        } = await supabase.auth.getSession();
        setSession(currentSession);
      } catch (error) {
        console.error("Auth error:", error);
      } finally {
        setLoading(false);
      }
    };

    getInitialSession();

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, currentSession) => {
      setSession(currentSession);
      setLoading(false);
    });

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  if (loading) {
    return (
      <div className="admin-loading-container">
        <div className="admin-loader"></div>
        <p>Verifying Admin Session...</p>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/about-us/our-leadership",
    element: <Leadership />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/quote",
    element: <GetQuote />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/testimonials",
    element: <TestimonialsArchive />,
  },
{
    path: "/products",
    element: <Products />, // Handles the Grid
  },
  {
    path: "/products/:productId",
    element: <Products />, // Now also handles the Detail view internally
  },
  {
    path: "/about-us/who-are-we",
    element: <Whoarewe />,
  },
  {
    path: "/about-us/customer-service-charter",
    element: <ServiceCharter />,
  },
  {
    path: "/claims",
    element: <ClaimForm />
  },
  {
    path: "/admin",
    element: (
      <AdminProtected>
        <Admin />
      </AdminProtected>
    ),
    children: [
      {
        path: "dashboard",
        element: <DashboardHome />,
      },
      {
        path: "roster",
        element: <Roster />,
      },
      {
        path: "testimonials",
        element: <TestimonialAdmin />,
      },
      {
        index: true,
        element: <Navigate to="dashboard" replace />,
      },
      {
        path: "claims",
        element: <AdminClaims />
      },
      {
        path: "quotes",
        element: <AdminQuotes />
      },
      {
        path : "contact",
        element: <AdminInquiries />
      },
      {
        path: "*",
        element: <Navigate to="/admin/dashboard" replace />,
      }
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

reportWebVitals();
